import React, { useState } from "react";
import Header from "@components/Header/Header";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import AadhaarRegistrationModal from "./components/aadhaarRegistrationModal";
import Introduction from "./components/introduction";
import bgImage from "../../assets/images/BG.svg";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LeftContainer from "./components/leftContainer";
import FooterCommonLogin from "@modules/public-comments/components/footerCommonLogin";

const Register = () => {
  // FAQ items
  const faqs = [
    {
      q: "What should I do if my NOC application is rejected?",
      a: "Review the remarks on your application dashboard, update the required details/documents, and re-submit. You’ll be informed via email/SMS when re-submission is allowed."
    },
    {
      q: "Can I edit my NOC application after submitting it?",
      a: "After final submission, editing is limited. If clarification is requested, use the portal to provide updates or additional documents."
    },
    {
      q: "How will I be notified about approval or additional requirements?",
      a: "Notifications are sent on your registered email/mobile and shown on your dashboard. Keep contact details up to date."
    },
    {
      q: "Do I need to be physically present for any inspection?",
      a: "If an inspection is scheduled, you’ll receive date/time and instructions. Presence may be required depending on the case."
    },
    {
      q: "What should I do if the portal shows an error while uploading documents?",
      a: "Check file size/format, clear cache, try another browser, and ensure a stable connection. If it persists, contact support."
    },
    {
      q: "What documents are required for submission?",
      a: "Required documents depend on the facility type. Refer to the application form checklist for the latest list and formats."
    }
  ];
  return (
    // <Box className="login-root" style={{ backgroundImage: `url(${bgImage})` }}>
    //   <Box className="page-content">
    //     {/* <Header /> */}
    //     <Box
    //       sx={{
    //         mt: 4,
    //         display: { md: "flex", xs: "block" },
    //         alignItems: { md: "baseline", xs: "stretch" },
    //       }}
    //     >
    //       <Introduction />
    //       <AadhaarRegistrationModal />
    //     </Box>
    //   </Box>
    // </Box>

    <>
      <Box
        sx={{
          backgroundImage: `linear-gradient(rgba(15,23,42,0.55), rgba(15,23,42,0.10)), url(${require("@assets/images/common-login-bg.png")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: { xs: 520, md: 400 },
          display: "flex",
          alignItems: "center",
          py: { xs: 4, md: 6 }
        }}
      >
        <Container maxWidth="xl" sx={{ px: { xs: 2, md: 8 } }}>
          <Grid container spacing={4} alignItems="center">
            {/* Left content */}
            <LeftContainer />

            {/* Right login card */}

            <AadhaarRegistrationModal />
          </Grid>
        </Container>
      </Box>

      {/* Contact Us */}
      <Box sx={{ bgcolor: "#F7F6FB" }}>
        <Container sx={{ py: { xs: 5, md: 8 } }}>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: { xs: 24 },
              color: "#3A1C73",
              mb: 1
            }}
          >
            Contact Us
          </Typography>

          <Typography
            sx={{
              textAlign: "center",
              color: "#757575",
              fontSize: { xs: 16, md: 14 },
              fontWeight: 400,
              maxWidth: 1024,
              mx: "auto",
              mb: 5
            }}
          >
            Get in touch with us for any queries regarding Access and Right of
            Way <br />
            Permissions along National Highways
          </Typography>

          <Grid container spacing={3} justifyContent="center" width="100%">
            {[
              {
                icon: (
                  <EmailOutlinedIcon sx={{ color: "#212121", fontSize: 28 }} />
                ),
                title: "Email Us",
                lines: ["support-rmp@gov.in"]
              },

              {
                icon: (
                  <AccessTimeOutlinedIcon
                    sx={{ color: "#3B1A77", fontSize: 28 }}
                  />
                ),
                title: "Address",
                lines: [
                  "Transport Bhawan, 1 Parliament",
                  "Street New Delhi - 110001, India"
                ]
              }
            ].map(card => (
              <Grid item xs={12} sm="auto" md="auto" key={card.title}>
                <Card
                  variant="outlined"
                  sx={{
                    width: 320,
                    height: "100%",
                    borderRadius: 3,
                    borderColor: "#E8E2D1",
                    px: { xs: 2, md: 3 },
                    py: { xs: 3, md: 4 },
                    mx: "auto"
                  }}
                >
                  <CardContent sx={{ textAlign: "center", p: 0 }}>
                    <Box
                      sx={{
                        display: "inline-flex",
                        width: 64,
                        height: 64,
                        borderRadius: 2,
                        bgcolor: "#F2EDF9",
                        border: "1px solid #E7DBFB",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2
                      }}
                    >
                      {card.icon}
                    </Box>

                    <Typography
                      sx={{
                        fontFamily:
                          "Inter, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial, sans-serif",
                        fontWeight: 700,
                        fontStyle: "normal",
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "-0.005em",
                        textAlign: "center",
                        color: "#111827",
                        mb: 1
                      }}
                    >
                      {card.title}
                    </Typography>

                    <Stack spacing={0.5}>
                      {card.lines.map(t => (
                        <Typography
                          key={t}
                          component={t.includes("@") ? "a" : "p"}
                          href={t.includes("@") ? `mailto:${t}` : undefined}
                          sx={{
                            color: t.includes("@") ? "#6B7280" : "#6B7280",
                            fontSize: 14,
                            fontWeight: 500,
                            textDecoration: "none",
                            "&:hover": t.includes("@")
                              ? { textDecoration: "underline" }
                              : undefined
                          }}
                        >
                          {t}
                        </Typography>
                      ))}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
      {/* FAQ */}
      <Box sx={{ bgcolor: "#fff" }}>
        <Container sx={{ py: { xs: 5, md: 5 } }}>
          <Typography
            sx={{
              textAlign: "center",
              fontWeight: 700,
              fontSize: { xs: 20, md: 18 },
              color: "#3A1C73",
              mb: 0.5
            }}
          >
            Frequently Asked Questions
          </Typography>
          <Typography
            sx={{
              textAlign: "center",
              color: "#6B7280",
              fontSize: { xs: 14, md: 14 },
              fontWeight: 400,
              mb: { xs: 3, md: 4 }
            }}
          >
            Find answers to common questions
          </Typography>

          {faqs.map(faq => (
            <Accordion
              key={faq.q}
              disableGutters
              square
              sx={{
                boxShadow: "none",
                borderRadius: 0,
                "&:before": { display: "none" },
                borderBottom: "1px solid #E5E7EB",
                width: "90%",
                alignItems: "center",
                mx: "auto"
                // mb: 2
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#6B7280" }} />}
                sx={{
                  px: 0,
                  minHeight: 48,
                  "& .MuiAccordionSummary-content": { my: 1 }
                }}
              >
                <Typography
                  sx={{ fontWeight: 500, fontSize: 14, color: "#212121" }}
                >
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 0, pb: 2 }}>
                <Typography sx={{ fontSize: 14, color: "#6B7280" }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>
      </Box>
      <FooterCommonLogin />
    </>
  );
};

export default Register;
